// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles__spinner___2jFqm","menuExpanded":"styles__menuExpanded___38tQF","menuNotExpanded":"styles__menuNotExpanded___1tG6l"};